import { deleteRequest, get, post, put } from '@/app/core/request';
import { UserRoutes } from '@/app/api-routes';

class UserApi {
  async getIsQualifiedForBenefits(customerUUID: string, communeId: number) {
    return get<boolean>(UserRoutes.qualifiedBenefits(customerUUID, communeId));
  }
  async generatePrinterCode(customerUUID: string, transactionId: number, taxcardIds: number[]): Promise<string> {
    return post<any>(UserRoutes.generatePrinterCode(customerUUID, transactionId), { taxcardIds }).then(
      data => data.printerCode
    );
  }
  async generateWalletPass(customerUUID: string, taxID: string, os: string, userId: string): Promise<BufferSource> {
    return get<any>(UserRoutes.generateWalletPass(customerUUID, taxID, os, userId));
  }
  async getUserTransactions(customerUUID: string): Promise<any[]> {
    return get<any[]>(UserRoutes.userTransactions(customerUUID));
  }
  async getAnnualCandidates() {
    return get<any>(UserRoutes.annualCandidate);
  }
  async getSavedPeople(): Promise<any> {
    return get<any>(UserRoutes.savedPerson);
  }
  async updateSavedPerson(person: any) {
    const data = { ...person };
    data.birthday = data.birthday.toISOString();
    return put(UserRoutes.savedPersonById(person.id), person);
  }
  async createSavedPerson(savedPerson: any) {
    return post(UserRoutes.savedPerson, savedPerson);
  }
  async deleteSavedPerson(id: number) {
    return deleteRequest(UserRoutes.savedPersonById(id));
  }
}

export default new UserApi();
